
import {defineComponent, PropType} from "vue";
import FullHeaderComponent from "@/components/recorder/partials/FullHeaderComponent.vue";
import {Campaign} from "@/models/campaign";
import FooterComponent from "@/components/recorder/partials/FooterComponent.vue";
import {Contribution, totalContributionDuration} from "@/models/contribution";
import {useAnalyticsStore} from "@/store/analytics.store";
import {mapActions} from "pinia";

export default defineComponent({
    name: "SuccessComponent",
    components: {FooterComponent, FullHeaderComponent},
    props: {
        campaign: { type: Object as PropType<Campaign>, required: true },
        contribution: { type: Object as PropType<Contribution>, required: true },
    },
    mounted() {
        this.trackEvent('creationSuccessView', {});
    },
    data() {
        return {
            linkCopied: false,
        };
    },
    computed: {
        isShownInNativeApp() {
            return typeof window.BeamsSDK !== 'undefined' && typeof window.BeamsSDK.finishScreenCTAClicked !== 'undefined';
        },
        shouldShowCTA() {
            return (this.campaign.successLink && this.campaign.successLinkLabel) || this.isShownInNativeApp;
        },
        ctaLabel() {
            if (this.campaign.successLinkLabel) {
                return this.campaign.successLinkLabel;
            } else {
                return this.$t('survey.closeSurveyButton');
            }
        },
        target(): string {
            if (!this.campaign.successLink) {
                return '_blank';
            }

            if (this.campaign.successLink?.indexOf("beams.fm") > -1 || this.campaign.successLink?.indexOf("alpha.b3ams.com") > -1 || this.campaign.successLink?.indexOf("localhost") > -1 || this.campaign.successLink?.indexOf("simonpal.eu.ngrok.io") > -1) {
                return '_top';
            } else {
                return '_blank';
            }
        }
    },
    methods: {
        ...mapActions(useAnalyticsStore, ['trackEvent']),
        copyLink() {
            if (!window.navigator.clipboard) {
                alert(this.$t('share.aLink.failed'));
                return false;
            }

            window.navigator.clipboard.writeText(this.campaign.contributionURL);

            this.linkCopied = true;
            setTimeout(() => {
                this.linkCopied = false;
            }, 3000);

            this.trackEvent('creationSuccessShareTapped', {
                ...this.$analytics.campaignParams(this.campaign),
                creationMode: 'ugc',
                duration: totalContributionDuration(this.contribution),
                hasImage: !!this.contribution.imageData,
            });

            return true;
        },
        didOpenCTA(event: Event) {
            this.trackEvent('creationSuccessCTATapped', {
                ...this.$analytics.campaignParams(this.campaign),
                creationMode: 'ugc',
                duration: totalContributionDuration(this.contribution),
                hasImage: !!this.contribution.imageData,
            });

            // In case when SDK is handling the final click, prevent URL from being opened
            if (typeof window.BeamsSDK !== 'undefined' && typeof window.BeamsSDK.finishScreenCTAClicked !== 'undefined') {
                event.preventDefault()
                window.BeamsSDK.finishScreenCTAClicked(this.campaign.successLink);
            }
        },
    },
});
